module.exports = __webpack_public_path__ + "img/tuto_internet_way_02_03.0ba13d04.png";